import { render, staticRenderFns } from "./giftInfo.vue?vue&type=template&id=a4a7691a&"
import script from "./giftInfo.vue?vue&type=script&lang=js&"
export * from "./giftInfo.vue?vue&type=script&lang=js&"
import style0 from "./giftInfo.vue?vue&type=style&index=0&id=a4a7691a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports